/**
 * Formats FastAPI/Pydantic validation errors into a human-readable string.
 * @param {any} detail - The error detail from the response (can be string or array of error objects).
 * @returns {string} - A formatted error message.
 */
export const formatError = (detail) => {
    if (!detail) return 'An unexpected error occurred';

    if (typeof detail === 'string') return detail;

    if (Array.isArray(detail)) {
        return detail.map(err => {
            const field = err.loc ? err.loc.join('.') : 'Field';
            const msg = err.msg || 'is invalid';
            return `${field}: ${msg}`;
        }).join('\n');
    }

    if (typeof detail === 'object') {
        return JSON.stringify(detail);
    }

    return String(detail);
};
